import { action, createRequestTypes } from 'utils/actions'

export const ENTITIES_VENUES = createRequestTypes('ENTITIES_VENUES')

export const venue = {
  request: (venueId) => action(ENTITIES_VENUES.REQUEST, { venueId }),
  success: (venueId, response) => action(ENTITIES_VENUES.SUCCESS, { venueId, response }),
  failure: (venueId, error) => action(ENTITIES_VENUES.FAILURE, { venueId, error }),
}

export const ENTITIES_VENUE_SEARCH_RESULTS = createRequestTypes('ENTITIES_VENUE_SEARCH_RESULTS')

export const venueSearchResults = {
  request: query => action(ENTITIES_VENUE_SEARCH_RESULTS.REQUEST, { query }),
  success: (response) => action(ENTITIES_VENUE_SEARCH_RESULTS.SUCCESS, { response }),
  failure: (error) => action(ENTITIES_VENUE_SEARCH_RESULTS.FAILURE, { error }),
}



/** WEBPACK FOOTER **
 ** ./src/actions/entities/venues/venues-actions.js
 **/